import { axiosAuthInstance } from "../utils/getSubdomain"
import { QuestionListFilter, QuestionPayload } from "./type"

export const postBulkQuestions = (data: FormData) => {
  return axiosAuthInstance.post("/upload-questions/", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  })
}

export const postSingleQuestion = (data: QuestionPayload) => {
  return axiosAuthInstance.post("/questions/insert/", data)
}

export const previewBulkQuestions = (bulk_question_id: string) => {
  return axiosAuthInstance.get(
    `/questions/preview/?bulk_session_id=${bulk_question_id}`
  )
}

export const editBulkQuestions = (data: any) => {
  return axiosAuthInstance.post("/questions/bulk-insert/", { ...data })
}

export const editSingleQuestion = (
  id: string,
  data: Partial<QuestionPayload>
) => {
  return axiosAuthInstance.put(`/question/update/${id}`, {
    ...data,
  })
}

export const getAllQuestion = (filter: Partial<QuestionListFilter>) => {
  const params = Object.fromEntries(
    Object.entries(filter).filter(
      ([, value]) => value !== "" && value !== null && value !== undefined
    )
  ) as Record<string, string | number>

  if (params.year) {
    params.year = Number(params.year)
  }

  return axiosAuthInstance.get("/questions/list/", {
    params,
  })
}

export const getQuestion = (id: string) => {
  return axiosAuthInstance.get(`/question/${id}/`)
}

export const deleteQuestion = (id: string) => {
  return axiosAuthInstance.delete(`/question/${id}/`)
}

export const publishQuestion = (id: string) => {
  return editSingleQuestion(id, { question_status: "published" })
}

export const archiveQuestion = (id: string) => {
  return editSingleQuestion(id, { question_status: "archived" })
}

export const setQuestionStatus = (
  id: string,
  question_status: "draft" | "published" | "archived"
) => {
  return editSingleQuestion(id, { question_status })
}

export const setLearnerPublish = (id: string, published_to_learner: boolean) => {
  return editSingleQuestion(id, { published_to_learner })
}

export const verifyQuestion = (
  id: string,
  status: "verified" | "rejected"
) => {
  return axiosAuthInstance.post(`/questions/${id}/verify`, { status })
}
